import React from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'

const Favicon = ({ content }) => {
  let favicon = '/favicon.ico'

  if (content?.code?.code) {
    const rawSVG = content?.code?.code
    const svg = rawSVG.trim()
    favicon =
      typeof window === 'undefined'
        ? `data:image/svg+xml;base64,${Buffer.from(svg).toString('base64')}`
        : `data:image/svg+xml;base64,${btoa(svg)}`
  }

  if (content?.portrait?.gatsbyImageData?.images) {
    favicon = content?.portrait?.gatsbyImageData?.images?.sources[0]?.srcSet.split(
      '?'
    )[0]
  }

  return (
    <Helmet>
      <link
        id="icon-favicon"
        rel="icon"
        href={favicon}
        type="image/png"
        sizes="16x16"
      />
    </Helmet>
  )
}

Favicon.defaultProps = {
  content: '',
}

Favicon.propTypes = {
  content: PropTypes.string,
}

export default Favicon
